import axios from 'axios'
import React, { useState, useEffect, useContext} from 'react'

import { Form, Button, Container, Col, Row, Card, ProgressBar, Alert, InputGroup, Modal } from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
// @type {PaymentsClient}
// @private
import AuthContext from '../../../context/AuthProvider';
const REGISTER_URL = 'http://localhost:8000/user/register'


export default function OrderRecieptSuccess() {
    const {auth, setAuth} = useContext(AuthContext)
    const navigate = useNavigate()
    const { session_id } = useParams();
    const [isMounted, didMount] = useState(false)
    const [loading, isLoading] = useState(true)

    
    const [paymentStatus, setPaymentStatus] = useState('')
    const [errorProcessingPayment, setErrorProcessingPayment] = useState(false)
    const [paymentIsStillProcessing, setPaymentIsStillProcessing] = useState(false)
    const [paymentFailed, setPaymentFailed] = useState(false)
    const [errMsg, setErrMsg] = useState('')


    const handleOrderResult = async (sess_id) => {
        setErrorProcessingPayment(false)
        setPaymentIsStillProcessing(false)
        setPaymentFailed(false)
        setPaymentStatus('')
        setErrMsg('')

        try {
             const response = await axios.post('/user/order/success', { 
                 session_id: sess_id,
                 user: auth,
                 accessToken: localStorage.getItem('accessToken')
             })

            // const data = {
            //     success: false,
            //     payment_status: 'failed',
            //     newAccessToken: 'newAccessToken',
            //     message: 'Payment failed. Please try again or contact us at csamwebteam@gmail.com.',
            // }

            const data = response.data
            
            if (data.success) {
                if (data.payment_status == 'succeeded') {
                    console.log('payment succeeded')
                    setPaymentStatus('succeeded')
                    console.log('data', data)
                    setAuth({...data.user, loggedIn: true})
                    localStorage.setItem("accessToken", data.newAccessToken)
                    localStorage.setItem("loggedIn", true)
                } else if (data.payment_status == 'processing') {
                    setPaymentStatus('processing')
                    setErrMsg(data.message)
                    setPaymentIsStillProcessing(true)
                }
            } else {
                setPaymentStatus('failed')
                setErrMsg(data.message)
                setPaymentFailed(true)
            }

            return data
        } catch (error) {
            setErrMsg(`There was an error finding your payment session. If you believe this is an error, please contact us at csamwebteam@gmail.com.`);
            setErrorProcessingPayment(true)
        } finally {
            didMount(true)
        }
    }

    useEffect(()=> {
        //Once page is loaded, get the session ID from the URL path and handle the order success
        console.log('Session ID:', session_id)
        //no session ID provided
        if (session_id){ 
            console.log(session_id)
            handleOrderResult(session_id)
        } else {
            console.log("No session ID provided. Redirecting to login.")
            navigate("/login", { replace: true })
        }

    },[])

    useEffect(()=> {
        if (isMounted) {
            isLoading(false)
        }
    },[isMounted])

    useEffect(()=> {
        if (paymentStatus == 'succeeded') {
            setTimeout(()=> {
                navigate("/myaccount", { replace: true })
            }, 5000)
        }
    },[paymentStatus])


    if (loading) {
        return (
            <>
            <Container className='mt-150'>
                <Row>
                    <Col xs={10} sm={8} className='mx-auto'>
                        <Card>
                             <Card.Body
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginTop: '20px',
                                    marginBottom: '20px',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    fontSize: '1rem'
                                }}
                             >
                                 <Spinner animation="border" role="status" style={{ width: '1rem', height: '1rem' }} /> 
                                 {/* <span>Processing...</span> */}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                </Container>
            </>
        )
    }

    if (!loading && errorProcessingPayment){
        return (
            <>
            <Container className='mt-150'>
                <Row>
                    <Col xs={10} sm={8} className='mx-auto'>
                        <Alert variant='danger'>
                            <p>{errMsg}</p>
                            
                            {/* <p> If this issue persists, please try again or contact us at <a href='mailto:csamwebteam@gmail.com'>csamwebteam@gmail.com</a>.</p> */}
                        </Alert>
                    </Col>
                </Row>
                </Container>
            </>
        )
    }

    if (!loading && paymentIsStillProcessing){
        return (
            <>
            <Container className='mt-150'>
                <Row>
                    <Col xs={10} sm={8} className='mx-auto'>
                        <Alert variant='warning'>
                            <p>{errMsg}</p>
                        </Alert>
                    </Col>
                </Row>
                </Container>
            </>
        )
    }
    
    if (!loading && paymentStatus == 'succeeded'){
        return (
            <>
            <Container className='mt-150'>
                <Row>
                    <Col xs={10} sm={8} className='mx-auto'>

                        <Alert variant='success'>
                            <p>
                                Congratulations <strong> { auth.displayname } </strong>, your membership has been successfully activated!
                            </p>

                            <p>
                                    You will be redirected to <a href="/myaccount"> My Account </a> in 5 seconds.
                            </p>
                        </Alert>   
                        
                    </Col>
                </Row>
                </Container>
            </>
    

        )}

    
    if (!loading && paymentFailed){
        return (
            <>
            <Container className='mt-150'>
                <Row>
                    <Col xs={10} sm={8} className='mx-auto'>
                        <Alert variant='danger'>
                            <p>{errMsg}</p>
                            <p>If you believe this is an error, please contact us at <a href='mailto:csamwebteam@gmail.com'>csamwebteam@gmail.com</a>.</p>
                        </Alert>
                    </Col>
                </Row>
                </Container>
            </>
        )
    }

}
